export default __webpack_public_path__ + "static/media/facebook-icon.fe72da65.png";